import React, { useEffect } from "react";
import { connect } from "react-redux";
import RegisterStepsNew from "../../components/UI/RegisterStepsNew/RegisterStepsNew.tsx";
import PersonaFormNew from "../../components/FormularioPersonaNew/FormularioPersonaNew.tsx";
import EmpresaFormNew from "../../components/FormularioEmpresaNew/FormularioEmpresaNew.tsx";
import styles from "./RegisterFormNew.module.scss";
import { fireAnalytics } from "../../utils/firebase.js";
import { CHANGE_TYPE } from "../../store/actions/types";
import { getCities } from "../../store/actions";
import { motion } from "framer-motion";
import { getSessionId, getDeviceCategory } from "../../utils/analyticsHelpers.ts";

const variants = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0 },
};

const RegisterFormNew = ({ type, user, onChangeHandler, ...props }) => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
    
    // Mantener evento antiguo durante transición
    fireAnalytics("ob_step_2", { category: "navigation" });
    
    // Nuevo evento estandarizado
    fireAnalytics("onboarding_step_2_view", {
      category: "onboarding",
      session_id: getSessionId(),
      device_category: getDeviceCategory(),
      action: "step_view",
      step: 2,
      account_type: type || ""
    });
  }, [type]);

  const actualYear = new Date().getFullYear();

  const form = type === "EMPRESA" ? <EmpresaFormNew {...props} /> : <PersonaFormNew {...props} />;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants}
      transition={{ duration: 0.5 }}
      className={styles.RegisterFormNewContainer}>
      <section className={styles.RegisterFormNew}>
        <div className={styles.RegisterFormNew_body}>
          <RegisterStepsNew stepCount={2} />
          <h1 className={styles.title}>
            Datos de la cuenta
            <br />
          </h1>
          <motion.div
            key={type}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            {form}
          </motion.div>
          <div className={styles.copyright}>
            Copyright © {actualYear} Edify, All rights reserved. Buenos Aires, Argentina.
          </div>
        </div>
      </section>
    </motion.div>
  );
};

const mapStateToProps = (state) => {
  return {
    type: state.register.type,
    user: state.general.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeHandler: (tipo) => dispatch({ type: CHANGE_TYPE, payload: tipo }),
    getCities: (jurisdictionId) => dispatch(getCities(jurisdictionId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterFormNew);
